export default __webpack_public_path__ + "static/media/permeable-blog-3.96883a8f.jpg";